// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import React from "react";
// @mui material components
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";

// I18N
import { useTranslation } from "react-i18next";

function Footer({ light }) {
  const { size } = typography;

  const { t } = useTranslation();

  return (
    <MDBox position="absolute" width="100%" bottom={0} py={1}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            component="ul"
            sx={({ breakpoints }) => ({
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              listStyle: "none",
              mt: 3,
              mb: 0,
              p: 0,

              [breakpoints.up("lg")]: {
                mt: 0,
              },
            })}
          >
            <MDBox component="li" pr={2} lineHeight={1}>
              <Link href="/privacy" target="_blank">
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  {t("common:footer.privacy")}
                </MDTypography>
              </Link>
            </MDBox>

            {/* <MDBox component="li" px={2} lineHeight={1}> */}
            {/* <Link href="https://www.creative-tim.com/presentation" target="_blank"> */}
            {/* <MDTypography variant="button" fontWeight="regular" color={light ? "white" : "dark"}>
                {t("common:footer.contact")}
              </MDTypography> */}
            {/* </Link> */}
            {/* </MDBox> */}
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="right"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={size.sm}
          >
            &copy; {new Date().getFullYear()}, Mecatronica Reefer - Francisco Luca
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
